import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Сертификат", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Абонемент", -1)
const _hoisted_4 = [
  _hoisted_3
]

import imageCert from "@/assets/images/certificates.jpeg";
import imageAbon from "@/assets/images/abonements.png";
import "../assets/cedra4f/stylesheet.css";
import "../assets/reset.css";
import shopForm from "@/components/shop-form.vue";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { TypeDesignObj } from "@/types/typesOfApi";


export default /*#__PURE__*/_defineComponent({
  __name: 'shop-main',
  setup(__props) {

const route = useRoute();

const salonId = route.params.SALON_ID as string | undefined;

const store = useStore();

const currentLoyalityKind = computed(() => store.state.currentLoyalityKind);

const currentSetDesing = computed(() => {
  const allDesingTypes: TypeDesignObj[] = store.state.allDesignTypes;

  if (allDesingTypes) {
    const setDesingId = store.state.loyalityShopData.designType;

    if (setDesingId) {
      return allDesingTypes.find((i: TypeDesignObj) => i.id === setDesingId)
        ?.image;
    } else {
      return null;
    }
  }

  return null;
});

function setTypeOfBuy(loyalityType: string): void {
  if (store.state.currentShopStep === 0) {
    store.state.currentShopStep++;
    store.state.currentLoyalityKind = loyalityType;
  }
}

return (_ctx: any,_cache: any) => {
  return (_unref(salonId))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["shop-main", { _g: !currentLoyalityKind.value }])
      }, [
        (currentLoyalityKind.value !== 'abonement')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["shop-main__card", {
        active: currentLoyalityKind.value === 'certificate',
        'mb-24px': !currentLoyalityKind.value,
      }]),
              style: _normalizeStyle({
        backgroundImage: `url(${
          currentSetDesing.value ? currentSetDesing.value : _unref(imageCert)
        })`,
      }),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setTypeOfBuy('certificate')))
            }, _hoisted_2, 6))
          : _createCommentVNode("", true),
        (currentLoyalityKind.value !== 'certificate')
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(["shop-main__card", { active: currentLoyalityKind.value === 'abonement' }]),
              style: _normalizeStyle({
        backgroundImage: `url(${
          currentSetDesing.value ? currentSetDesing.value : _unref(imageAbon)
        })`,
      }),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setTypeOfBuy('abonement')))
            }, _hoisted_4, 6))
          : _createCommentVNode("", true),
        (currentLoyalityKind.value)
          ? (_openBlock(), _createBlock(shopForm, { key: 2 }))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})